// 产品详情页————产品导航
// document.addEventListener('DOMContentLoaded', function() {
//   setTimeout(function() {
//     var siteHeader = document.querySelector('.shopify-section--header');
//     if (siteHeader) {
//       var headerHeight = siteHeader.offsetHeight;
//       var productNav = document.querySelector('.shopify-section--product-nav');
//       if (productNav) {
//         productNav.style.top = headerHeight - 2 + 'px';
//       }
//     }
//     if(window.innerWidth < 1024) {
//       var table_row_sticky = document.querySelector('.feature-chart__table-row--sticky');
//       table_row_sticky.style.top = productNav.offsetHeight + 59 + 'px';
//     }
//   }, 1500);
// });
document.querySelectorAll('.product_nav_item').forEach(function(item) {
  item.addEventListener('click', function() { 
    document.querySelectorAll('.product_nav_item').forEach(function(otherItem) {
      otherItem.classList.remove('active');
    });
    item.classList.add('active');
    var dataName = item.getAttribute('data-name');
    var targetElement = document.querySelector('[data-title="' + dataName + '"]');
    if (targetElement) {
      var elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({ top: elementPosition - 100, behavior: 'smooth' });
    }
  });
});
window.addEventListener('scroll', function() {
  var foundActive = false;
  document.querySelectorAll('.product_nav_item').forEach(function(item) {
    var dataName = item.getAttribute('data-name');
    var targetElement = document.querySelector('[data-title="' + dataName + '"]');
    if (targetElement) {
      var elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
      var elementHeight = targetElement.offsetHeight;
      var scrollPosition = window.pageYOffset + window.innerHeight / 2;

      if (!foundActive && scrollPosition >= elementPosition && scrollPosition < elementPosition + elementHeight) {
        document.querySelectorAll('.product_nav_item').forEach(function(otherItem) {
          otherItem.classList.remove('active');
        });
        item.classList.add('active');
        foundActive = true;
      } else {
        item.classList.remove('active');
      }
    }
  });
});

document.querySelectorAll('.selling_point_container').forEach(function(container) {
  var listItems = container.querySelectorAll('li');
  listItems.forEach(function(li, index) {
    if (index !== 0) {
      li.style.display = 'none';
    }
  });
});

const showButton = document.querySelector('.show_button');
if (showButton) {
  showButton.addEventListener('click', function() {
    var previousUl = this.previousElementSibling;
    var isHidden = previousUl.classList.toggle('hidden');
    
    if (isHidden) {
      this.querySelector("span").textContent = 'Show More';
      this.querySelector("svg").style.transform = 'rotate(0deg)';
      previousUl.querySelectorAll('li:not(:first-child)').forEach(function(li) {
        li.style.display = 'none';
      });
    } else {
      this.querySelector("span").textContent = 'Show Less';
      this.querySelector("svg").style.transform = 'rotate(180deg)';
      previousUl.querySelectorAll('li:not(:first-child)').forEach(function(li) {
        li.style.display = 'list-item';
      });
    }
    
    previousUl.style.transition = 'all 0.5s ease';
  });
}

// 弹窗
document.addEventListener('DOMContentLoaded', function() {
  var dialog = document.getElementById('dialog');
  var overlay = document.getElementById('dialog-overlay');
  var closeDialog = document.getElementById('close-dialog');
  var serviceItems = document.querySelectorAll('.service_item');

  function openDialog() {
    dialog.classList.remove('hidden');
    overlay.classList.remove('hidden');
    document.body.style.overflow = 'hidden';
  }

  function closeDialogFunc() {
    dialog.classList.add('hidden');
    overlay.classList.add('hidden');
    document.body.style.overflow = 'auto';
  }

  closeDialog.addEventListener('click', closeDialogFunc);
  overlay.addEventListener('click', closeDialogFunc);

  serviceItems.forEach(function(item) {
    item.addEventListener('click', function() {
      var dialogHeader = document.getElementById('dialog_header');
      var dialogContent = document.getElementById('dialog_content');
      var dialogTitle = item.getAttribute('data-dialogTitle');
      var dialogText = item.getAttribute('data-content');
      
      if (dialogHeader) {
        dialogHeader.textContent = dialogTitle;
      }
      if (dialogContent) {
        dialogContent.innerHTML = dialogText;
      }
      console.log('dialogTitle===========', dialogTitle);
      console.log('dialogText===========', dialogText);
    });
    item.addEventListener('click', openDialog);
  });

  // Example of opening the dialog
  // openDialog();
});
